import styled from 'styled-components';

export const InfiniteScrollContainer = styled.section`
  //overflow-y: scroll;
  width: 100%;
`;
